// src/components/ui/calendar/month/MonthViewEventsContainer/MonthViewEventsContainerShadcn.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';

const MonthViewEventsContainerShadcn = ({
  children,
  className = ''
}) => {
  return (
    <div className={cn(
      // Exact styling from your current MonthView events container
      "flex flex-col gap-0.5 overflow-hidden",
      className
    )}>
      {React.Children.map(children, (child, index) => (
        <div key={index} className="flex-shrink-0">
          {child}
        </div>
      ))}
    </div>
  );
};

export default MonthViewEventsContainerShadcn;